<div class="attendee-row">
  <div class="attendee-details">
    @if (!isRegistered) {
      <div class="marker-yellow"></div>
    }
    @if (isRegistered) {
      <div class="marker-green"></div>
    }
    {{ attendee.person.name }}
  </div>
  @if (isEditMode) {
    <div class="attendee-options">
      <mat-checkbox class="attendee-register" (click)="toggleRegister($event)" [checked]="isRegistered">Registered</mat-checkbox>
      <mat-checkbox class="attendee-invite" (click)="toggleOutlookInvite($event)" [checked]="attendee.isOnOutlook">Send Outlook Invite</mat-checkbox>
    </div>
  }
  @if (isEditMode) {
    <button matTooltip="Delete attendee" (click)="remove(attendee)"><mat-icon>delete_outline</mat-icon></button>
  }
</div>
